import Axios from "axios";

export const SelectTVAFrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FacFrs?type=FF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "TVAF_SELECT", payload: response.data });
    });
  };
};
